export class ProductsLanguages {
    public static panel: string[] = ["fr", "en", "es", "it", "pt", "nl", "de", "pl"];

    public static content: string[] = [
        "fr", "en", "es", "it", "pt", "nl", "de", "lb", "da",
        "pl", "ro", "cs", "hu", "sk", "bg", "sv", "fi", "no", "el", "tr", "hr", "sl"
    ];

    public static panelCountries: { code: string, languages: string[], nativeFor?: string }[] = [
        // Pays anglophones
        {code: "gb", languages: ["en"], nativeFor: "en"},
        {code: "us", languages: ["en"]},
        {code: "ie", languages: ["en"]},
        {code: "au", languages: ["en"]},
        {code: "nz", languages: ["en"]},
        {code: "za", languages: ["en"]},
        {code: "ca", languages: ["en", "fr"]},

        // Pays du Golfe (anglophones + arabophones)
        {code: "ae", languages: ["en", "ar"]},
        {code: "sa", languages: ["en", "ar"], nativeFor: "ar"},
        {code: "qa", languages: ["en", "ar"]},
        {code: "bh", languages: ["en", "ar"]},
        {code: "kw", languages: ["en", "ar"]},
        {code: "om", languages: ["en", "ar"]},

        // Asie du Sud
        {code: "in", languages: ["en", "hi", "bn"], nativeFor: "hi"},
        {code: "pk", languages: ["en", "ur"], nativeFor: "ur"},
        {code: "bd", languages: ["bn"], nativeFor: "bn"},

        // Asie du Sud-Est
        {code: "sg", languages: ["en", "zh", "ms"]},
        {code: "hk", languages: ["en", "zh"]},
        {code: "ph", languages: ["en", "tl"], nativeFor: "tl"},
        {code: "my", languages: ["en", "ms"], nativeFor: "ms"},
        {code: "id", languages: ["en", "id"], nativeFor: "id"},
        {code: "th", languages: ["en", "th"], nativeFor: "th"},
        {code: "vn", languages: ["en", "vi"], nativeFor: "vi"},

        // Afrique (anglophones)
        {code: "ng", languages: ["en"]},
        {code: "ke", languages: ["en"]},
        {code: "gh", languages: ["en"]},
        {code: "eg", languages: ["en", "ar"]},

        // Pays francophones
        {code: "fr", languages: ["fr"], nativeFor: "fr"},
        {code: "be", languages: ["fr", "nl", "de"]},
        {code: "ch", languages: ["fr", "de", "it"]},
        {code: "lu", languages: ["lb", "fr", "de"], nativeFor: "lb"},
        {code: "sn", languages: ["fr"]},
        {code: "ma", languages: ["fr", "ar"]},
        {code: "dz", languages: ["fr", "ar"]},
        {code: "tn", languages: ["fr", "ar"]},
        {code: "ci", languages: ["fr"]},
        {code: "bf", languages: ["fr"]},
        {code: "cm", languages: ["fr"]},
        {code: "mg", languages: ["fr"]},
        {code: "ht", languages: ["fr"]},
        {code: "cd", languages: ["fr"]},
        {code: "mu", languages: ["fr"]},

        // DOM-TOM français
        {code: "gp", languages: ["fr"]},
        {code: "mq", languages: ["fr"]},
        {code: "gf", languages: ["fr"]},
        {code: "re", languages: ["fr"]},
        {code: "yt", languages: ["fr"]},
        {code: "nc", languages: ["fr"]},
        {code: "pf", languages: ["fr"]},
        {code: "pm", languages: ["fr"]},
        {code: "wf", languages: ["fr"]},
        {code: "mf", languages: ["fr"]},

        // Pays germanophones
        {code: "de", languages: ["de"], nativeFor: "de"},
        {code: "at", languages: ["de"]},

        // Europe occidentale
        {code: "it", languages: ["it"], nativeFor: "it"},
        {code: "es", languages: ["es"], nativeFor: "es"},

        // Amérique Latine (hispanophones)
        {code: "mx", languages: ["es"]},
        {code: "ar", languages: ["es"]},
        {code: "co", languages: ["es"]},
        {code: "cl", languages: ["es"]},
        {code: "pe", languages: ["es"]},
        {code: "ec", languages: ["es"]},
        {code: "gt", languages: ["es"]},
        {code: "cr", languages: ["es"]},
        {code: "pa", languages: ["es"]},
        {code: "uy", languages: ["es"]},
        {code: "pr", languages: ["es"]},

        {code: "pt", languages: ["pt"], nativeFor: "pt"},
        {code: "br", languages: ["pt"]},
        {code: "nl", languages: ["nl"], nativeFor: "nl"},
        {code: "dk", languages: ["da"], nativeFor: "da"},

        // Europe centrale et de l'Est
        {code: "pl", languages: ["pl"], nativeFor: "pl"},
        {code: "ro", languages: ["ro"], nativeFor: "ro"},
        {code: "md", languages: ["ro"]},
        {code: "cz", languages: ["cs"], nativeFor: "cs"},
        {code: "hu", languages: ["hu"], nativeFor: "hu"},
        {code: "sk", languages: ["sk"], nativeFor: "sk"},
        {code: "bg", languages: ["bg"], nativeFor: "bg"},

        // Pays nordiques
        {code: "se", languages: ["sv"], nativeFor: "sv"},
        {code: "fi", languages: ["fi"], nativeFor: "fi"},
        {code: "no", languages: ["no"], nativeFor: "no"},
        {code: "is", languages: ["en"]},

        // Pays hellénophones et turcophones
        {code: "gr", languages: ["el"], nativeFor: "el"},
        {code: "cy", languages: ["el", "tr"]},
        {code: "tr", languages: ["tr"], nativeFor: "tr"},

        // Balkans
        {code: "hr", languages: ["hr"], nativeFor: "hr"},
        {code: "si", languages: ["sl"], nativeFor: "sl"},
        {code: "rs", languages: ["sr"], nativeFor: "sr"},

        // Pays baltes
        {code: "lt", languages: ["lt"], nativeFor: "lt"},
        {code: "lv", languages: ["lv"], nativeFor: "lv"},
        {code: "ee", languages: ["et"], nativeFor: "et"},

        // Asie de l'Est
        {code: "jp", languages: ["ja"], nativeFor: "ja"},
        {code: "kr", languages: ["ko"], nativeFor: "ko"},
        {code: "cn", languages: ["zh"], nativeFor: "zh"},

        // Moyen-Orient
        {code: "il", languages: ["he"], nativeFor: "he"},

        // Ukraine
        {code: "ua", languages: ["uk"], nativeFor: "uk"}
    ];

    public static website: string[] = ["fr", "en", "es", "it", "pt", "nl", "de", "pl"];
}
